import React from 'react';
import Icon from '../../../components/AppIcon';

const PriorityAlertSummary = ({ summary, onCategoryClick }) => {
  const cards = [
    {
      id: 'compliance',
      title: 'Compliance Violations',
      icon: 'AlertTriangle',
      criticalCount: summary?.complianceViolations?.count || 0,
      totalCount: summary?.complianceViolations?.total || 0,
      color: 'error',
      bgColor: 'bg-error/10',
      textColor: 'text-error',
      description: 'PNG Employment Act breaches, NASFUND discrepancies, SWT errors'
    },
    {
      id: 'deadline',
      title: 'Deadline Warnings',
      icon: 'Clock',
      criticalCount: summary?.deadlineWarnings?.count || 0,
      totalCount: summary?.deadlineWarnings?.total || 0,
      color: 'warning',
      bgColor: 'bg-warning/10',
      textColor: 'text-warning',
      description: 'Upcoming compliance submissions, payroll dates, filing requirements'
    },
    {
      id: 'payroll',
      title: 'Payroll Errors',
      icon: 'DollarSign',
      criticalCount: summary?.payrollErrors?.count || 0,
      totalCount: summary?.payrollErrors?.total || 0,
      color: 'accent',
      bgColor: 'bg-accent/10',
      textColor: 'text-accent',
      description: 'Calculation failures, validation issues, processing bottlenecks'
    },
    {
      id: 'widget',
      title: 'Widget Performance',
      icon: 'Activity',
      criticalCount: summary?.widgetPerformance?.count || 0,
      totalCount: summary?.widgetPerformance?.total || 0,
      color: 'primary',
      bgColor: 'bg-primary/10',
      textColor: 'text-primary',
      description: 'Dashboard load times, API delays, engagement drops'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
      {cards?.map((card) => (
        <div
          key={card?.id}
          onClick={() => onCategoryClick?.(card?.id)}
          className="bg-card border border-border rounded-lg p-5 sm:p-6 hover:shadow-md transition-smooth cursor-pointer"
        >
          {/* Header */}
          <div className="flex items-start justify-between gap-3 mb-4">
            <div className={`flex items-center justify-center w-12 h-12 rounded-lg ${card?.bgColor} flex-shrink-0`}>
              <Icon name={card?.icon} size={24} color={`var(--color-${card?.color})`} />
            </div>
            {card?.criticalCount > 0 && (
              <span className={`px-2 py-1 text-xs font-bold rounded-full ${card?.bgColor} ${card?.textColor} whitespace-nowrap flex-shrink-0`}>
                {card?.criticalCount} Critical
              </span>
            )}
          </div>

          {/* Title */}
          <h3 className="font-heading text-base sm:text-lg font-semibold text-foreground mb-2 break-words">
            {card?.title}
          </h3>

          {/* Count */}
          <div className="flex items-baseline gap-2 mb-3">
            <span className={`font-heading text-2xl sm:text-3xl font-bold ${card?.textColor}`}>
              {card?.totalCount}
            </span>
            <span className="text-xs sm:text-sm text-muted-foreground whitespace-nowrap">total alerts</span>
          </div>

          {/* Description */}
          <p className="text-xs text-muted-foreground break-words overflow-hidden" style={{display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical'}}>
            {card?.description}
          </p>
        </div>
      ))}
    </div>
  );
};

export default PriorityAlertSummary;
